import Sidebar from "../components/common/Sidebar";
import NotificationBell from "../components/notifications/NotificationBell";
import HHSyncIssuesButton from "../components/hh/HHSyncIssuesButton";
import HeaderSubmenu from "../components/common/HeaderSubmenu";

export default function MainLayout({ children, className, contentClassName }) {
    return (
        <div className="flex bg-slate-50 min-h-screen text-slate-800">
            <Sidebar />
            <div className="flex-1 min-w-0 flex flex-col">
                <header className="sticky top-0 z-30 flex items-center justify-end gap-3 px-4 lg:px-6 py-2 bg-slate-50/90 backdrop-blur-sm border-b border-slate-200/60">
                    <HeaderSubmenu />
                    <HHSyncIssuesButton />
                    <NotificationBell />
                </header>
                <div className={`flex-1 px-4 py-4 lg:px-6 min-w-0 ${className ?? ""}`}>
                    <div className={`max-w-[2400px] mx-auto ${contentClassName ?? ""}`}>{children}</div>
                </div>
            </div>
        </div>
    );
}
